/**
 * here it is assumed that the template are alrady loaded into dom
 * as facet.js should be included before this file
 */

var ProductSearch = function(){
	$.extend(Handlebars.templates, Handlebars.partials);
	var self = this;
	this.contentResultsTemplate = Rayban.templates.content_result_template;


	this.preprocess = function(){
		$(document).on("click","#newSearchContainer .wcs-slide-search-btn", this.newSearchButtonHandler);

		$(document).on("keyup","#newSearchContainer .new-search-text", this.newSearchTextKeyupHandler);


		this.onSearchPageLoad();
	};



	this.showLoadingSearchResult = function () {
		$('#wcs-loading-search-results').height($(document).height()).show();
	}

	this.hideLoadingSearchResult = function () {
		$('#wcs-loading-search-results').height(0).hide();
	}
	this.onSearchPageLoad = function(){

		if($("#pageType").val() =='SearchResults'){
			var $searchProductURL = $("#searchPageURL").val();

			self.showLoadingSearchResult();

			var prams = {
					"viewMode" : $("#viewMode").val(),
					"searchType": $("#searchType").val(),
					"searchTermScope": $("#searchTermScope").val(),
					"sType": $("#sType").val(),
					"newpage": $("#newpage").val(),
					"facet": getUrlParameter('facet'),
					"clientSide": $("#clientSide").val(),
					"pageSize": getUrlParameter('pageSize'),
					"searchTerm" : getUrlParameter('searchTerm').split("+").join(" "),
					"orderBy" : getUrlParameter('orderBy')
			};

			$.ajax({
			  url: $searchProductURL,
			  data: prams,
			  type: 'get',
			  traditional : true,
			  success: function(data){

				if(typeof data != "object")
					data = $.parseJSON(data);
					self.successSearchReuslt(data,self);
			  }
			});
		}
	};

	this.newSearchButtonHandler = function(){
		self.removeQuerystringFromUrl("facet");
		self.removeQuerystringFromUrl("orderBy");
		globalAppliedFactes = "";
		$('.wcs-filter-inner-container > div').slideUp('fast');
		$('.wcs-filter-link').removeClass('wcs-active').find('.wcs-down_arrow').animate({
            top: 0
        }, 100);
		if($('#D_Search_Top_NewSearchEnter').val() !== ''){
			var $searchProductURL = $("#searchPageURL").val();

			self.showLoadingSearchResult();

			var prams = {
					"viewMode" : $("#viewMode").val(),
					"searchType": $("#searchType").val(),
					"searchTermScope": $("#searchTermScope").val(),
					"sType": $("#sType").val(),
					"newpage": $("#newpage").val(),
					"facet": getUrlParameter('facet'),
					"clientSide": $("#clientSide").val(),
					"pageSize": $('#newPageSize').val(),
					"searchTerm" : $('#D_Search_Top_NewSearchEnter').val()
			};

			$.ajax({
			  url: $searchProductURL,
			  data: prams,
			  type: 'get',
			  traditional : true,
			  success: function(data){

				if(typeof data != "object")
					data = $.parseJSON(data);
					self.successSearchReuslt(data,self);
			}
			});
		}
	};

	this.newSearchTextKeyupHandler = function(event){
		if(event.keyCode === 13){
			self.newSearchButtonHandler();
		}
	};
	this.successSearchReuslt = function(data,self){
		var regName = /"[^"]*"/;
		var pageTitleRegExp = /"[^"]*"$/;
		var totalCount = Number(data.totalCount);
		var newPageSize = $("#newPageSize").val();
		updateUrlParameter("searchTerm",data.searchTerm);
		updateUrlParameter("pageSize",newPageSize);
		var productData = [];
		if(data.products!=undefined){
			productData = new Array($.parseJSON(data.products));
		}
		var contentData = $.parseJSON(data.contentdata);
		var pagesCount;
		if(contentData && contentData!== null){
			pagesCount = Number(contentData.totalContentCount);
		}else{
			pagesCount = 0;
		}
		/*tealium_data2track.push({
			id:'WCS-X-Search-PageReady',
			Search_ResultItemsQnt: totalCount,
			Search_ResultPagesQnt: pagesCount,
			Search_Keyword: data.searchTerm
		});*/
		if(contentData && contentData!== null){
			contentData.paginationCount = self.getContentPageCount(contentData.totalContentCount);
			self.loadContentResults(contentData, data.searchTerm);
		}
		if((contentData !== null && contentData.totalContentCount!==0)||(totalCount !== 0)){
			$("#espotContainer").show();
		}else{
			$("#espotContainer").hide();
		}
		if(pagesCount ===0 && totalCount === 0){
			$(".search-suggestions-container").show();
			$("#DESK_Search_NoProductsBanners").show();
			$("#DESK_Search_MostPopular").show();
			$(".wcs-search-pages-title").hide();
		}else if(pagesCount !==0 &&  totalCount === 0){
			$(".search-suggestions-container").hide();
			$("#DESK_Search_NoProductsBanners").hide();
			$("#DESK_Search_MostPopular").show();
			$(".wcs-search-pages-title").show();
		}else{
			$(".search-suggestions-container").hide();
			$("#DESK_Search_NoProductsBanners").hide();
			$("#DESK_Search_MostPopular").hide();
			$(".wcs-search-pages-title").show();

		}
		$('#pageNumber').val("1");
		$('#pageSize').val($("#newPageSize").val());
		$("#shownProductCount span:first-child").text($("#newPageSize").val());
		$("#shownProductCount .totalCount").text(" "+totalCount);
		$("#shownProductCount .totalCountText").text(" "+data.totalCountText);
		if(contentData !== null && contentData.totalContentCount!==0){
			var newHeading;
			if(totalCount === 0){
				$(".wcs-page-results-cntr").show();
				$("#pagesResultTitle").hide();
				$("#NopagesResultTitle").show();
				$("#NopagesResultTitle").find('h2:first-child').text(data.contentTermText);
				var noPageTitleString = $("#NopagesResultTitle h2:last-child").html();
				if(noPageTitleString !== undefined){
					newHeading = noPageTitleString.replace(pageTitleRegExp, '"'+getUrlParameter('searchTerm').split("+").join(" ") +'"');
					$("#NopagesResultTitle h2:last-child").html(newHeading);
				}
				$("#NopagesResultTitle").find('h2:last-child .product-count').text(contentData.totalContentCount);
			}else{
				$(".wcs-page-results-cntr").show();
				$("#pagesResultTitle").show();
				$("#NopagesResultTitle").hide();
				$("#pagesResultTitle").find('h2:first-child').text(data.contentTermText);
				var pageTitleString = $("#pagesResultTitle h2:last-child").html();
				if(pageTitleString !== undefined){
					newHeading = pageTitleString.replace(pageTitleRegExp, '"'+getUrlParameter('searchTerm').split("+").join(" ") +'"');
					$("#pagesResultTitle h2:last-child").html(newHeading);
				}
				$("#pagesResultTitle").find('h2:last-child .product-count').text(contentData.totalContentCount);
			}
		}else{
			$(".wcs-page-results-cntr").hide();
			$("#pagesResultTitle").hide();
			$("#NopagesResultTitle").hide();
		}
		var newSubHeading = null;

		window.plpView.render(productData);

		if(undefined !== productData && undefined !== productData[0] && undefined !== productData[0].products &&
				undefined !== productData[0].products.product && productData[0].products.product.length){
			$('#pageSize').val(productData[0].products.product.length);
			$("#shownProductCount span:first-child").text(" "+$('#pageSize').val());
			updateUrlParameter("pageSize",$('#pageSize').val());
		}

		if(totalCount === 0){
      $('#search .wcs-search-product-title').css('width', '969px');
			$("#filterByDivArea").hide();
			$("#facetDivArea").hide();
			$(".wcs-search-results-cntr").hide();

			var noSearchTitleString = $("#NosearchResultTitle h1").html();
			if(noSearchTitleString !== undefined){
				newSubHeading = noSearchTitleString.replace(regName, '"'+getUrlParameter('searchTerm').split("+").join(" ") +'"');
				$("#NosearchResultTitle h1").html(newSubHeading);
			}
			$("#NosearchResultTitle h2 .product-count").hide();
			$(".wcs-no-search-results-cntr").show();

			$("#NosearchResultTitle h2").text(data.totalCountText);

			$("#NosearchResultTitle").show();
			$("#searchResultTitle").hide();

			$("#newSearchContainer").addClass('no-products');

			if(data.spellCorrection !==undefined){
				$("#spellCorrectionLink").show();
				var spellCorrectionLink = $("#spellCorrectionLink").find(".spell-correction-suggestion a");
				spellCorrectionLink.attr("href",data.spellCorrection.url.split("amp;").join(""));
				spellCorrectionLink.text(data.spellCorrection.label);

			}else{
				$("#spellCorrectionLink").hide();
			}

		}else {
			$(".wcs-no-search-results-cntr").hide();

			var searchTitleString = $("#searchResultTitle h1").html();
			if(searchTitleString !== undefined){
				newSubHeading = searchTitleString.replace(regName, '"'+getUrlParameter('searchTerm').split("+").join(" ") +'"');
				$("#searchResultTitle h1").html(newSubHeading);
			}

			$("#newSearchContainer").removeClass('no-products');

			window.facetView.fetchFacetData();


			$("#filterByDivArea").show();
			$("#facetDivArea").show();
			$(".wcs-search-results-cntr").show();

			$("#NosearchResultTitle").hide();
			$("#searchResultTitle").show();

			$("#searchResultTitle h2 .product-count").show();
			$("#searchResultTitle h2").html(data.totalCountText);
			$("#searchResultTitle h2").prepend("<span class='product-count'>"+totalCount+" </span>");




			if(data.nextPageURL){
				$("#searchResultsLoadMoreContainer").show();
				var loadMoreURL = data.nextPageURL.split("amp;").join("");
				$("#nextPageSearch").val(loadMoreURL);
			}else{
				$("#searchResultsLoadMoreContainer").hide();
			}

		}

		if(data.nextContentPageURL){
			var nextContentPageUrl = data.nextContentPageURL.split("amp;").join("");
			$("#nextContentPageUrl").val(nextContentPageUrl);
		}
		self.hideLoadingSearchResult();

    /*$(".colorsCarouselOverlay ul").each(function () {
      var self = $(this);
      var plpCarousel = $(this).bxSlider({
        infiniteLoop: false,
        hideControlOnEnd: true,
        slideWidth: 92,
        pager: false,
        minSlides: 1,
        maxSlides: 3,
        moveSlides: 3,
        preloadImages: 'all',
        responsive: false,
        onSliderLoad: function () {
          setTimeout(function () {
            if (self.find("li").length > 4) {
              $(self.closest(".bx-wrapper").find(".bx-controls .bx-controls-direction a.bx-next")).eq(0).removeClass("disabled");
            } else {
              $(self.closest(".bx-wrapper").find(".bx-controls .bx-controls-direction a.bx-next")).eq(0).addClass("disabled");
            }
          }, 200);
        }
      });
    });*/
  };


	this.loadContentResults = function(contentData, searchTerm){

		$("#contentResultContainer").html(this.contentResultsTemplate(contentData));

        if(contentData.contents && contentData.contents.length > 0){
        	$('#contentResultContainer .content-result a, #contentResultContainer .content-result div').wrapInTag({
        		tag: 'strong',
        		words: searchTerm.split(" ")
        	});
        }
	};

	this.getContentPageCount = function(totalCount){
		var paginationCount = [];
		var pageCount =Math.ceil(totalCount/10);
		for(var i=0; i<pageCount;i++){
			var pageNumberObj={};
			pageNumberObj.pageNumber = i+1;
			if(i === 0)
				pageNumberObj.className = "selected";

			paginationCount.push(pageNumberObj);
		}
		if(paginationCount.length >1){
			return paginationCount;
		}

	};

	this.removeQuerystringFromUrl = function(queryString){
		var url = location.href;
		while(url.indexOf(queryString) !== -1){

			if(url.indexOf("?"+queryString)!=-1){
				url = url.replace(new RegExp("\\?"+queryString+"=[^&]+"),"");
			}
			if(url.indexOf("&"+queryString)!=-1){
				url = url.replace(new RegExp("&"+queryString+"=[^&]+"),"");
			}
		}
		history.replaceState(null, null, url);

	};
};

$(function(){
	window.productSearchObj = new ProductSearch();
	productSearchObj.preprocess();
});
